import type { Container } from "pixi.js";

export type NoteEffectStyle = "halo-particles" | "halo" | "none";

export const NOTE_EFFECT_STYLES: readonly NoteEffectStyle[] = [
  "halo-particles",
  "halo",
  "none",
];

export const DEFAULT_NOTE_EFFECT_STYLE: NoteEffectStyle = "halo-particles";

/**
 * A strike crossing the playhead — a note of a piano lane, or a key held on
 * the local piano that no lane has written (the view is parked, or the key is
 * the one that started the transport) — projected into roll-local coordinates.
 */
export type ActivePress = {
  midi: number;
  /** Center X of the key (in roll-local pixels). */
  x: number;
  /** Y coordinate of the playhead line. */
  y: number;
  /** Width of the key in pixels. */
  keyWidth: number;
  /** Effect color (matched note color, or fallback). 0xRRGGBB. */
  color: number;
  /** Note-on velocity, 0–1. Drives effect intensity. */
  velocity: number;
};

export type NoteEffectFrame = {
  presses: readonly ActivePress[];
  /** Wall-clock delta in milliseconds since last update. */
  deltaMS: number;
  /**
   * La vitesse du rouleau, en part de sa vitesse nominale : 1 au tempo de
   * référence du morceau, 2 quand les notes filent deux fois plus vite — que
   * ce soit un tempo écrit ou le curseur de vitesse.
   *
   * Un effet libre de s'en servir ou pas. Ce qui jaillit d'une frappe gagne à
   * suivre le morceau ; ce qui décrit une durée physique, comme l'extinction
   * d'une corde, n'a rien à y voir.
   */
  rollSpeedRatio: number;
  width: number;
  height: number;
};

export interface NoteEffect {
  update(frame: NoteEffectFrame): void;
  /** True while the effect still has in-flight animation (e.g. fading particles). */
  isAnimating(): boolean;
  destroy(): void;
}

export type NoteEffectFactory = (parent: Container) => NoteEffect;
